import {
  ClientEntityType,
  Investor,
  Fund,
  Instrument,
} from "@/entities/client";
import { ImportTemplateField } from "@/types";
import { Account } from "./shared";
import { FundEntityType } from "./fund/FundEntityType";
import {
  Holding,
  HoldingWithInstrument,
  Transaction,
  TransactionWithInstrument,
} from "./fund";

export const mapEntityTypeToFields = (
  entityType: string
): ImportTemplateField[] => {
  switch (entityType) {
    case ClientEntityType.Account:
      return Account;
    case ClientEntityType.Investor:
      return Investor;
    case ClientEntityType.Fund:
      return Fund;
    case ClientEntityType.Account:
      return Account;
    case ClientEntityType.Instrument:
      return Instrument;
    case FundEntityType.Transaction:
      return Transaction;
    case FundEntityType.TransactionWithInstrument:
      return TransactionWithInstrument;
    case FundEntityType.HoldingWithInstrument:
      return HoldingWithInstrument;
    case FundEntityType.Holding:
      return Holding;
  }
  return [];
};
